export default {
    "entityName": "request",
    "title": false,
    "upsert": "full",
    "pagination": {
        "rowsPerPage": 10,
        "page": 1,
        "sortBy": "id",
        "descending": true
    },
    "fields": [
        {
            "value": "id",
            "text": "ID",
            "table": {
                "sortable": true,
                "filter": true
            }
        },        
        {
            "value": "request_date",
            "text": "Request date",
            "type": "datetime",
            "table": {
                "sortable": true,
                "filter": true
            }
        },
        {
            "value": "protocol_id",
            "text": "Protocol",
            "type": "autocomplete",
            "title": "name",
            "table": {
                "text": "name",
                "filter": true
            }
        },        
        {
            "value": "provider_id",
            "text": "Provider",
            "type": "autocomplete",
            "title": "name",
            "table": {
                "text": "name",
                "sortable": true,
                "filter": true
            }
        },
        {
            "value": "first_request",
            "text": "First request",
            "table": true,
            "type": "check"
        },
        {
            "value": "status",
            "text": "Status",
            "type": "list",
            "list": ["NEW", "CONFIRMED", "REPLIED"],
            "title": "status",
            "table": {
                "text": "name",
                "filter": true
            }
        },
        {
            value: 'request_drugs.name',
            text: 'Drugs',
            id: 'id',
            filter: (item, search) => [{ 'request_drugs.name': `%${search}%` }],
            subtitle: item => `${item.dose}${item.measure_unit} - ${item.protocol.name}`,
            type: 'autocomplete',
            table: {
                filter: true,
            },
            render: item => 
                item.request_drugs && item.request_drugs.reduce((drugs, drug, idx) => drugs + `${drug.name}(${drug.dose + drug.measure_unit}, ${item.drugs[idx] && (item.drugs[idx].n_pieces)}) ` , ''),
            visible: false
        }        
    ],
    "actions": ["upsert"]
}